/* eslint-disable no-invalid-this,no-unused-vars,no-use-before-define */
import router from '@/router/router';
import store from '@/store/store';
import moment from 'moment';

export const MAINTENANCE_NOTIFY_HEADER = 'X-SM-Maintenance-Notify'.toLowerCase();
export const MAINTENANCE_REDIRECT_HEADER = 'X-SM-Maintenance-Redirect'.toLowerCase();

export const parseHeader = (headerValue) => {
  const maintenanceStr = headerValue;
  const maintenanceParsed = maintenanceStr.split(';');
  const maintenanceProperties = maintenanceParsed.map(p => p.split('='));
  const duration = maintenanceProperties.find(p => p[0] === 'duration');
  const start = maintenanceProperties.find(p => p[0] === 'start');
  const maintenance = {
    duration: duration ? moment.duration(duration[1]) : null,
    start: moment(Number(start[1]))
  };
  return maintenance;
};
